module.exports = __webpack_public_path__ + "media/95.ba499612.mp3";